import request from './index'

const baseUrl = process.env.NODE_ENV === 'development' ? '/api/' : 'https://www.ihzdc.com/' // 线上

export const getList = () => request.get(baseUrl + 'allapi/list')
export const getDetail = (aid) => request.get(baseUrl + 'allapi/detail?aid=' + aid)
